import React, { useEffect, useState } from "react";
import { Button, Breadcrumb } from "antd";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import CoinImage from "../../assets/images/header-coin-icon.svg";
import FeatureImage from "../../assets/images/feature-product-image.png";
import PlusImage from "../../assets/images/plus-image.svg";
import Main from "../../components/layout/Main";
import { useNavigate } from "react-router";
import { MinusOutlined, PlusOutlined, HeartFilled } from "@ant-design/icons";
import { Heart, ShoppingCart, Share2 } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import { Severty, ShowToast } from "../../helper/toast";
import { useParams } from "react-router";
import CommonBreadcrumb from "../../components/BreadCrumb";
import UniversalShareModal from "../../components/UniversalShareModal";

const ProductDetails = () => {
  const navigate = useNavigate();
  const { storeId, id } = useParams();
  const {
    addCartItem,
    loadProductById,
    loadVendorProducts,
    loadCartItems,
    cart,
    refreshCart,
    likeProduct,
    revokeLike,
  } = useStore();
  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState(null);
  const [productID, setProductID] = useState(null);
  const [products, setProducts] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);

  // const [itemsExistInCart, setItemsExistInCart] = useState(false);

  // ------------ handlers ------------
  const fetchProduct = async (id) => {
    const response = await loadProductById(id);
    // prefer context cart for instant state; fallback to API
    let cartData = cart;
    if (!cartData) {
      const carts = await loadCartItems();
      cartData = carts?.data;
    }
    // const exists = Array.isArray(cartData?.items)
    //   ? cartData.items.some((item) => item.productId === id)
    //   : false;
    // setItemsExistInCart(exists);
    setProduct(response.data);
    const result = await loadVendorProducts(storeId);
    if (response.success) {
      setProducts(result.data.data);
    }
  };

  const handleAddCartItem = async (id, quantity) => {
    const response = await addCartItem(id, quantity);
    if (response.status === 200) {
      ShowToast(response.message, Severty.SUCCESS);
      fetchProduct(id);
      await refreshCart();
    } else {
      ShowToast(response.error, Severty.ERROR);
    }
  };

  const handleCheckout = async (id, quantity) => {
    await handleAddCartItem(id, quantity);
    navigate("/checkout");
  };

  const handleLike = async (productId) => {
    try {
      let response;
      if (product?.isLiked) {
        response = await revokeLike(productId);
      } else {
        response = await likeProduct(productId);
      }
      if (response.success) {
        fetchProduct(productId);
      }
    } catch (error) {
      console.log("error occured when like the product", error);
      ShowToast(error.error, Severty.ERROR);
    }
  };

  // ------------ use effect ------------
  useEffect(() => {
    fetchProduct(productID || id);
  }, [productID]);

  return (
    <>
      <Main>
        <CommonBreadcrumb
          items={[
            { title: "Home", url: "/home" },
            { title: "Stores", url: "/stores" },
            { title: product?.vendor, url: `/stores/${storeId}` },
            { title: product?.name },
          ]}
        />
        <section className="product-detail-section">
          <div className="product-detail-main-box">
            <div className="product-full-image">
              <img src={product?.images?.[0] || FeatureImage} alt="product" />
              {product?.isLiked ? (
                <HeartFilled
                  className="like-icon"
                  onClick={() => handleLike(product._id)}
                  style={{ fontSize: 22, color: "red" }}
                />
              ) : (
                <Heart
                  className="like-icon product-like-icon"
                  onClick={() => handleLike(product._id)}
                />
              )}
              <Share2
                className="product-share-icon"
                onClick={() => setShareOpen(true)}
              />
            </div>
            <div className="product-detail-main-page">
              <div className="pruduct-detail-headding">
                <h5>{product?.name} </h5>
              </div>
              <div className="product-detail-menus">
                <ul>
                  <li>
                    <h6>Brand</h6>
                    <p>{product?.brand || "N/A"}</p>
                  </li>
                  <li>
                    <h6>Model</h6>
                    <p>{product?.model || "N/A"}</p>
                  </li>

                  <li>
                    <h6>Color</h6>
                    <p>{product?.color || "N/A"}</p>
                  </li>
                  <li>
                    <h6>Warranty</h6>
                    <p>{product?.warranty || "N/A"}</p>
                  </li>
                  <li>
                    <h6>Price in Tokens</h6>
                    <p>{product?.price || "N/A"}</p>
                  </li>

                  <li>
                    <h6>Price in KD</h6>
                    <p>{product?.price || "N/A"}</p>
                  </li>

                  <li>
                    <h6>Estimate in USD</h6>
                    <p>{product?.price || "N/A"}</p>
                  </li>
                </ul>
                <div className="quantity-selector">
                  <Button
                    icon={<MinusOutlined />}
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    shape="circle"
                  />
                  <span>{quantity}</span>
                  <Button
                    icon={<PlusOutlined />}
                    onClick={() => setQuantity(quantity + 1)}
                    shape="circle"
                  />
                </div>
              </div>
              <div className="product-description">
                <strong>Description</strong>
                <p>{product?.description || "N/A"}</p>
              </div>
              <div className="action-buttons">
                <Button
                  icon={<ShoppingCart />}
                  className="add-to-cart"
                  onClick={() => {
                    handleAddCartItem(product._id, quantity);
                  }}
                >
                  {/* {itemsExistInCart ? "Added ✓" : "Add to Cart"} */}
                  Add to Cart
                </Button>
                <Button
                  className="buy-now"
                  onClick={async () => handleCheckout(product._id, quantity)}
                >
                  Buy Now
                </Button>
              </div>
            </div>
          </div>
        </section>
        {products.length > 1 && (
          <section className="product-detail-list-section">
            <div className="orange-header">You may also like</div>
            <div className="store-featured-card-main">
              {products
                ?.filter((product) => product._id !== id)
                ?.map((product, index) => (
                  <div
                    key={index}
                    className="feature-product-card"
                    onClick={() => setProductID(product._id)}
                  >
                    <img src={product?.images?.[0] || FeatureImage} />

                    <div className="feature-text">
                      <div className="feature-text-innerr all-stored-grid">
                        <h5>{product?.name}</h5>

                        <h6>
                          <img src={CoinImage} /> 800
                        </h6>

                        <h6>{product?.price} KD</h6>
                      </div>

                      <span
                        className="add-plus-span"
                        onClick={() => {
                          handleAddCartItem(product._id, 1);
                        }}
                      >
                        <img src={PlusImage} />
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          </section>
        )}
      </Main>
      <UniversalShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={window.location.href}
      />
    </>
  );
};

export default ProductDetails;
